import * as React from "react";
import { Form, List } from "semantic-ui-react";
import { CUSTOMER_USER_CASE_TYPES, CaseType } from "@teamprevent/common/model";

import { OrgStructureDetailModel } from "../orgStructure/models";

import { ALL_ORG_STRUCTURES, CustomerUserCaseTypeOrgStructures } from "./models";

interface Props {
    caseTypeOrgStructures: CustomerUserCaseTypeOrgStructures[];
    customerOrgStructures: OrgStructureDetailModel[];
}

export const readonlyCaseTypeOrgStructuresList = (
    caseTypeOrgStructures: CustomerUserCaseTypeOrgStructures[],
    customerOrgStructures: OrgStructureDetailModel[]) => {

    const customerOrgStructureLevelOneCount = customerOrgStructures.filter(cos => !cos.parentId).length;
    const customerUserOrgStructures = caseTypeOrgStructures?.filter(p => p.orgStructures && p.orgStructures?.length > 0) ?? [];
    return (
        <List>
            {customerUserOrgStructures.map(orgStructure => {
                const caseTypeOrgStructure = CUSTOMER_USER_CASE_TYPES.find(x => x.value === orgStructure.value);
                const caseTypeOrgStructureDisplayName = caseTypeOrgStructure.displayName;
                const orgStructureLevelsCount = orgStructure.orgStructures.length;
                const orgStructureLevels = caseTypeOrgStructures
                    .find(os => os.value === caseTypeOrgStructure.value)?.orgStructures
                    .map(os => os.name)
                    .join(", ");
                const areLinkedImmunisationCasesIncluded =
                    orgStructure.value === CaseType.PPQ
                    && orgStructure.includeLinkedImmunisationCases;
                const linkedImmunisationCasesListItem = areLinkedImmunisationCasesIncluded ?
                    (
                        <List.Item key={ `${orgStructure.value}-linkedImmunisationCases` }>
                            PPQ Linked Immunisation Cases
                        </List.Item>
                    )
                    : <></>;

                const isAllAccess = orgStructure.orgStructures.some(os => os.id === ALL_ORG_STRUCTURES);
                if (isAllAccess || orgStructureLevelsCount === customerOrgStructureLevelOneCount) {
                    return (
                        <>
                            <List.Item key={orgStructure.value}>
                                {`${caseTypeOrgStructureDisplayName} (All)`}
                            </List.Item>
                            { linkedImmunisationCasesListItem }
                        </>
                    );
                }

                return (
                    <>
                        <List.Item key={orgStructure.value}>
                            {`${caseTypeOrgStructureDisplayName} (${orgStructureLevelsCount}/${customerOrgStructureLevelOneCount}: ${orgStructureLevels})`}
                        </List.Item>
                        { linkedImmunisationCasesListItem }
                    </>
                );
            })}
        </List>
    );
};

export const ReadonlyCaseTypeOrgStructures: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <>
            <Form.Field>
                <label>View all cases for</label>
            </Form.Field>
            {readonlyCaseTypeOrgStructuresList(props.caseTypeOrgStructures, props.customerOrgStructures)}
        </>
    );
};
